import type { ChecklistItem, Faq, ProcessStep } from '../types/site';

export const fleetPoints: string[] = [
  'Semi, box truck and service body repairs',
  'Fleet color matching and commercial refinishing',
  'Include insurance or purchase-order details with your photos',
];

export const processSteps: ProcessStep[] = [
  {
    number: '01',
    title: 'Send the details',
    description: 'Share your vehicle type, damage photos and whether it rolls.',
  },
  {
    number: '02',
    title: 'Discuss the repair',
    description: 'Talk through the damage, repair scope and assessment.',
  },
  {
    number: '03',
    title: 'Plan the next step',
    description: 'Coordinate scheduling and your required return date with the shop.',
  },
];

export const faqs: Faq[] = [
  {
    question: 'What should I include with a quote request?',
    answer:
      'Include the unit type, a few clear photos of the damage, whether the vehicle rolls or drives, and the date you need it back. The quote form accepts photo uploads. Photos start the conversation about your repair — the repair scope and estimate can be discussed with the shop.',
  },
  {
    question: 'Do you repair box truck roofs, walls and doors?',
    answer:
      'Yes. Box truck work includes roof, wall, floor and door repairs, along with collision-damaged bodies. Send photos of the affected area and a short description of what happened so the shop can discuss the repair with you.',
  },
  {
    question: 'Can you match fleet paint colors?',
    answer:
      'Yes. Commercial refinishing and fleet color matching are part of the paint work. If your fleet uses specific colors or paint codes, include them with your quote request so they are part of the first conversation.',
  },
  {
    question: 'How long will the repair take?',
    answer:
      "Timing depends on damage, parts, repair scope and the shop's schedule. Discuss your required return date when requesting a quote.",
  },
];

export const quoteChecklist: ChecklistItem[] = [
  { title: 'Unit type', description: 'Semi, box truck, service body, trailer or RV.' },
  { title: 'Damage photos', description: 'A few clear angles of the damaged area.' },
  { title: 'Can it be driven?', description: 'Tell us whether it drives or needs transport.' },
  { title: 'Return date', description: 'When you need the unit back in service.' },
];
